
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IAuthorPayload, IDeleteDataResponseAndPayload } from '@src/types/api/author';


export async function saveAuthor(data: IAuthorPayload): Promise<AxiosResponse<TResponse<IAuthorPayload>>> {
    return axios.post<TResponse<IAuthorPayload>>(API_ENDPOINTS.AUTHOR_SAVE, data)
}

export async function listAuthor(qData: QData): Promise<AxiosResponse<TResponseWithQData<IAuthorPayload[]>>> {
    return axios.get(API_ENDPOINTS.AUTHOR_LIST, {
        params: qData
    })
}

export async function deleteAutor(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.AUTHOR_DELETE, data)
}

export async function authorDetail(_id: string): Promise<AxiosResponse<TResponse<IAuthorPayload>>> {
    return axios.get(`${API_ENDPOINTS.AUTHOR_DETAILS}/${_id}`);
}
